import React, { lazy, Suspense, useState, useEffect } from "react";
import "./App.css";
import CacheBuster from "react-cache-buster";
import { CookieSetting } from "cookiesetting-component";
import appversion from "../package.json";
import AngelAIWidget from "./AngelAIWidget";
import { useHyperlink } from "./contexts/HyperlinkProvider";

const Navbar = lazy(() => import("./components/Navbar/Navbar"));
const Header = lazy(() => import("./components/Header"));
const Body = lazy(() => import("./components/Body"));
const Contact = lazy(() => import("./components/ContactUs"));
const SubFooter = lazy(() => import("./components/SubFooter"));
const Footer = lazy(() => import("./components/Footer"));

function App() {
  const appVersion = appversion.version;

  const [angelAiLink, setAngelAiLink] = useState('');
  const [sunwestShortLink, setSunWestShortLink] = useState('');
  const [sunwestLink, setSunWestLink] = useState('');
  const [celligenceLink, setCelligenceLink] = useState('');
  const [celligenceLlcLink, setCelligenceLlcLink] = useState('');
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swShortLink = await getHyperLink('websites', 'swmc', 0);
      const swLink = await getHyperLink('websites', 'swmc', 1);
      const aiLink = await getHyperLink('websites', 'angelai', 0);
      const cellLink = await getHyperLink('websites', 'celligence', 1);
      const celliLlcLink = await getHyperLink('websites', 'celligence', 0);
      setAngelAiLink(aiLink || 'AngelAi');
      setSunWestShortLink(swShortLink || 'Sun West');
      setSunWestLink(swLink || 'Sun West Mortgage Company, Inc.');
      setCelligenceLink(cellLink || 'Celligence');
      setCelligenceLlcLink(celliLlcLink || 'Celligence LLC');
    };
    processContent();
  }, [getHyperLink]);

  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
    >
      <>
        <Suspense fallback={<div />}>
          <Navbar fetchpriority="high"/>
        </Suspense>
        <Suspense fallback={<div />}>
          <Header angelAiLink={angelAiLink}/>
        </Suspense>
        <Suspense fallback={<div />}>
          <Body angelAiLink={angelAiLink} sunwestLink={sunwestLink} sunwestShortLink={sunwestShortLink}/>
        </Suspense>
        <Suspense fallback={<div />}>
          <Contact sunwestLink={sunwestLink} sunwestShortLink={sunwestShortLink} celligenceLink={celligenceLink}/>
        </Suspense>
        <Suspense fallback={<div />}>
          <SubFooter angelAiLink={angelAiLink} sunwestLink={sunwestLink} celligenceLlcLink={celligenceLlcLink}/>
        </Suspense>
        <Suspense fallback={<div />}>
          <Footer sunwestLink={sunwestLink}/>
        </Suspense>
        <CookieSetting 
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
        />
        <AngelAIWidget userType={"default"} />
      </>
    </CacheBuster>
  );
}

export default App;
